<script setup>
import Logo from '@/Shared/Logo.vue'
import TextInput from '@/Shared/TextInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm, usePage } from '@inertiajs/vue3'

const isProduction = usePage().props.environment === 'production'

let form = useForm({
  email: !isProduction ? 'admin@courtcontrol.es' : '',
  password: !isProduction ? 'password' : '',
  remember: false
})

function login() {
  form.post('/login')
}
</script>

<template>
  <div
    class="flex items-center justify-center p-6 min-h-screen bg-gradient-to-b from-indigo-900 to-indigo-800"
  >
    <div class="w-full max-w-md">
      <div class="flex justify-center mb-8">
        <Logo
          class="text-center text-4xl justify-center"
          logo-classes="w-24 h-24"
          text-classes="text-2xl lg:text-3xl"
        />
      </div>
      <form
        class="bg-white rounded-lg shadow-xl overflow-hidden transition-all duration-300 transform hover:shadow-2xl"
        @submit.prevent="login"
      >
        <div class="px-10 py-10">
          <TextInput
            v-model="form.email"
            :error="form.errors.email"
            label="Email"
            type="email"
            autofocus
            autocapitalize="off"
            class="mb-6"
          />
          <TextInput
            v-model="form.password"
            :error="form.errors.password"
            label="Password"
            type="password"
          />
          <label class="flex items-center mt-6 select-none" for="remember">
            <input
              id="remember"
              v-model="form.remember"
              class="mr-2 h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              type="checkbox"
            />
            <span class="text-sm text-gray-700">Mantenerme conectado</span>
          </label>
        </div>
        <div class="px-10 py-6 bg-gray-50 border-t border-gray-100 flex justify-end">
          <LoadingButton
            :loading="form.processing"
            class="btn-indigo transition-all duration-200 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            type="submit"
          >
            Iniciar sesión
          </LoadingButton>
        </div>
      </form>
      <div class="mt-6 text-center text-sm text-indigo-200">
        &copy; {{ new Date().getFullYear() }} Court Control. Todos los derechos reservados.
      </div>
    </div>
  </div>
</template>
